import React from 'react'
import { Link } from 'react-router-dom'
import bg1 from '../../assets/images/background/bg-1.png'
import bg2 from '../../assets/images/background/bg-2.png'
import { useContent } from '../../services'

const offerImages = {
  'offer-image-1.jpg': require('../../assets/images/resource/offer-image-1.jpg'),
  'offer-image-2.jpg': require('../../assets/images/resource/offer-image-2.jpg'),
  'offer-image-3.jpg': require('../../assets/images/resource/offer-image-3.jpg'),
};

function Offer() {
  const { data: offersData, loading } = useContent('homeOffers');

  if (loading || !offersData) return null;

  return (
    <>
      <section className="we-offer-section">
        <div className="left-bot-bg"><img src={bg1} alt="" title="" /></div>
        <div className="right-top-bg"><img src={bg2} alt="" title="" /></div>
        <div className="auto-container">
          <div className="title-box centered">
            <div className="subtitle"><span>{offersData.subtitle}</span></div>
            <div className="pattern-image">
              <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
            </div>
            <h2>{offersData.title}</h2>
            <div className="text">{offersData.text}</div>
          </div>
          <div className="row justify-content-center clearfix">
            {offersData.items.map((offer, index) => (
              <div key={offer.id} className="offer-block col-xl-4 col-lg-4 col-md-6 col-sm-12">
                <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay={`${index * 300}ms`}>
                  <div className="image"><Link to={offer.link}><img src={offerImages[offer.image]} alt="" /></Link></div>
                  <h3><Link to={offer.link}>{offer.title}</Link></h3>
                  <div className="more-link"><Link to={offer.link}>{offersData.cta.label}</Link></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

export default Offer
